<template>
  <div class="landing-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="" style="text-align: center">
            <img style="width: 35%;margin-top: 50px" src="../../static/images/logo.png">
          </div>
          <div class="middle">
            <img src="../../static/images/login_pic1.png">
          </div>
          <div class="input-div" style="margin-top:-240px;position: relative; z-index: 999;">
            <div class="span mt30 fs33 fw7" style="font-weight: 400;margin-bottom: 15px;color: white">
              {{ $t('phoneNumber') }}
            </div>
            <div class="input-item">
              <div class="input-item2"
                   style="background: rgba(255, 255, 255, 0.85);border: 2px solid #1229b3;position: relative;margin: 0 auto;">
                 <span class="app-en">
                    <img style="vertical-align: middle;" src="../../static/images/input_09.png">
                  </span>
                <input class="input" style="color: black" v-model="mobile" disabled placeholder="">
              </div>
            </div>

            <div class="span fs33 app-en fw7" style="font-weight: 400;margin-bottom: 15px;color: white">OTP</div>
            <div class="input-item" style="background: none;">
              <div class="input-item2 disflex"
                   style="background: rgba(255, 255, 255, 0.85);border: 2px solid #1229b3;position: relative;margin: 0 auto;">
                <input class="input-item input" v-model="otp" ref="getFocus2" maxlength="6" type="number"
                       style="width: 100%;height:80px;" placeholder="">
                <button class="btn btn-red"
                        style="padding: 0 10px;min-height: 80px;line-height: 80px;min-width: 200px;margin-left:5px;font-size: 30px;"
                        :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')"
                        @click="getSendOtp">{{ codeText }}
                </button>
              </div>
            </div>

            <div style="text-align: center">
              <button class="button fw7" style="font-size:50px; margin-top: 60px" @click="goLogin">{{ $t('Login') }}
              </button>
            </div>
          </div>
          <div class="ac otp-b disflex mt100 por login-footer">
            <div  class="icon icon2 login_help" @click="getChange('termsAndCondition')">{{ $t('TC') }}</div>
            <div  class="icon icon2 login_help" @click="getChange('faq')">{{ $t('FAQ') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import CryptoJS from '../../static/js/crypto-js.min.js'

export default {
  components: {

  },
  data() {
    return {
      list: [],
      mobile: '',
      password: '',
      otp: '',
      codeText: '',
      isReturn: false,
      isEN: 'bur'

    }
  },
  watch: {
    otp(now, old) {
      let that = this;
      that.$nextTick(function () {
        if (now.length == 4 || old == now) {
          that.timer = setTimeout(() => {
            that.$refs.getFocus2.blur();
          }, 100);
        }
      });
    },
  },
  created() {
    this.codeText = this.$t('getCode')
    if (this.$route.query.msidn) {
      let ss = this.aesEcbDecrypt(this.$route.query.msidn);
      this.mobile = this.dealPhone_2(ss);
      this.getSendOtp();
    }
  },
  methods: {
    getType(type) {
      this.$router.push({path: '/' + type, query: {type: type}});
    },
    back() {
      this.$router.go(-1);
    },
    getSendOtp() {
      let that = this
      if (that.isReturn) {
        return;
      }
      that.isReturn = true
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      let data = {
        'mobile': mobile
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/login_send_otp', data, r => {
        that.isReturn = false
        that.$parent.loadModal(false);
        that.$utils.alertText(r.msg, 80, 3000);
        if (r.code == 1) {
          this.countDown(61, 1)
        }
      })
    },
    goLogin() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      const userAgent = navigator.userAgent;
      const deviceId = this.getDeviceId();
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      let data = {
        'mobile': mobile,
        'otp': this.otp,
        'user_agent': userAgent,
        'device_id': deviceId
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/verify_otp', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          let mobile = '09' + this.mobile
          mobile = that.dealPhone(mobile)
          let encryptedMobile = that.aesEcbEncrypt(mobile);
          that.$parent.loadModal(true);
          window.location.href = "/app?msidn=" + encodeURIComponent(encryptedMobile);
        } else {
          that.$utils.alertText(r.msg, 80);
        }
      })
    },
    // 计时
    countDown(miao, type) {
      if (miao === 1) {
        this.codeText = this.$t('getCode');
        return;
      }
      miao--;
      if (type === 1) {
        this.codeText = miao + "s";
        this.isReturn = false
      }
      setTimeout(() => {
        this.countDown(miao, type);
      }, 1000)
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
    //加密
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm"); // 16字节密钥
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);

      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    //解密
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          {ciphertext: encrypted},
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
      } catch (e) {

        return "";
      }
    },
    getChange(type) {
      let that = this;
      that.$router.push({path: '/' + type})
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
  }
}
</script>
<style scoped>
.landing-page {
  min-height: 100vh;
  background-size: cover !important;
}

.middle img {
  top: 300px !important;
  width: 520px !important;
  max-width: 90% !important;
}

.input-div .app-en {
  padding: 0 !important;
  margin-right: 10px;
}

.input-div .app-en img {
  width: 120px !important;
  height: auto;
  display: inline-block;
}
.input-div input.input {
  height: 76px !important;
  line-height: 76px !important;
  font-size: 42px !important;
  font-weight: 700 !important;
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
}

.otp-b {
  justify-content: space-evenly;
}

.login {
  margin-top: 0px;
}

.btn-red {
  padding: 20px 20px;
  background: #dd4765;
  width: auto;
  height: auto;
  display: block;
  margin: 0 auto;
  font-size: 40px;
}

.login-footer {
  margin-top: 270px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/otp.vue